import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import MyProfilePage from './my-profile'
import MyGaragePage  from './my-garage'

import component from './profile.component'

let module = angular.module('profileModule', [
  uiRouter,
  MyProfilePage,
  MyGaragePage
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('profile', {
      url: '/profile',
      component: 'profilePage',
      redirectTo: 'profile.myProfile',
      authenticate: true,
      myRenaultForbidden: true
    })
})

.component('profilePage', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/profile/index.js